<template>
  <!-- 对话框 -->
  <el-dialog title="发票审核" :visible.sync="show" :before-close="closeDialog" style="width:60%; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box" style="max-height: 70vh; overflow-y: auto;">
      <el-form label-width="80px">



        <el-form-item label="发票审核:" label-width='120px'>

          <el-radio-group v-model="submit_data.verify_status">
            <el-radio-button label="1">通过</el-radio-button>
            <el-radio-button label="2">拒绝</el-radio-button>
          </el-radio-group>

        </el-form-item>

        <!-- <el-form-item label="是否邮寄:" label-width='120px'>

          <el-radio-group v-model="submit_data.is_mail">
            <el-radio-button label="1">邮寄</el-radio-button>
            <el-radio-button label="2">不邮寄</el-radio-button>
          </el-radio-group>

        </el-form-item> -->

        <!-- <el-form-item label="是否发送至邮箱:" label-width='120px'>

          <el-radio-group v-model="submit_data.is_push_email">
            <el-radio-button label="1">发送</el-radio-button>
            <el-radio-button label="0">不发送</el-radio-button>
          </el-radio-group>

        </el-form-item> -->


<!--        <el-form-item label="pdf在线地址:" label-width='120px'>-->
<!--          <el-input v-model="submit_data.pdf_address"-->
<!--                    type="textarea" autosize-->
<!--            :placeholder="submit_rules.pdf_address.placeholder">-->
<!--          </el-input>-->
<!--        </el-form-item>-->


        <el-form-item label="备注:" label-width='120px'>
          <el-input type="textarea" autosize v-model="submit_data.verify_remarks"
            :placeholder="submit_rules.verify_remarks.placeholder">
          </el-input>
        </el-form-item>



      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="determineonSubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.submit_data.order_invoice_code = _this.data;

      },

    },
    data() {
      return {

        show: false,


        // 表单数据
        submit_data: {
          order_invoice_code: '',
          verify_status: '',
          verify_remarks: '',
          is_push_email:'',
          // pdf_address:'',
          // is_mail:''
        },

        submit_rules: {
          verify_status: {
            placeholder: '审核判定',
            rules: {
              required: true,
              message: '未选择审核判定状态',
              regulation: 'special',
              rulesData: '0|1'
            }
          },
          verify_remarks: {
            placeholder: '备注',
            rules: {
              required: false,
              message: '角色名200个汉字以下',
              regulation: 'elt_str',
              rulesData: 200
            }
          },
          is_push_email: {
            placeholder: '是否发送邮箱',
            rules: {
              required: false,
              message: '未选择是否发送邮箱',
              regulation: 'special',
              rulesData: '0|1'
            }
          },
          // pdf_address: {
          //   placeholder: 'pdf在线地址',
          //   rules: {
          //     required: false,
          //     message: 'pdf在线地址错误',
          //     regulation: 'gt_str',
          //     rulesData: 0
          //   }
          // },
          // is_mail: {
          //   placeholder: '是否邮寄',
          //   rules: {
          //     required: false,
          //     message: '未选择是否邮寄',
          //     regulation: 'special',
          //     rulesData: '0|1'
          //   }
          // },
        },

      };
    },
    created() {
      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {

        _this.show = false;

        _this.submit_data = {
          order_invoice_code: '',
          verify_status: '',
          verify_remarks: '',
          is_push_email:'',
          // pdf_address:'',
          // is_mail:''
        }

      },

      // 提交按钮
      determineonSubmit() {

        _this.$post(
            '/order/editOrderInvoiceSubmit',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {
            _this.$message.success(res.msg)
            // 向父组件通讯刷新表格内容
            _this.$emit('onSubmit');
            // 关闭对话框
            _this.closeDialog();

          }).catch((err) => {

          })

      }
    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;

  }

  .el-form-item__content {
    position: relative;
  }
</style>
